import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BoxComponent } from './components/box/box.component';
import { ButtonToggleComponent } from './components/button-toggle/button-toggle.component';
import { ButtonComponent } from './components/button/button.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { ErrorComponent } from './components/error/error.component';
import { IconComponent } from './components/icon/icon.component';
import { InputContainerComponent } from './components/input-container/input-container.component';
import { InputComponent } from './components/input/input.component';
import { LinkComponent } from './components/link/link.component';
import { LoadFormComponent } from './components/load-form/load-form.component';
import { LoadingSpaceFormComponent } from './components/loading-space-form/loading-space-form.component';
import { ModalTooltipComponent } from './components/modal-tooltip/modal-tooltip.component';
import { ProIconComponent } from './components/pro-icon/pro-icon.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { OptionComponent } from './components/select/option/option.component';
import { SelectComponent } from './components/select/select.component';
import { SlideToggleComponent } from './components/slide-toggle/slide-toggle.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TooltipDirective } from './components/tooltip/tooltip.directive';
import { ClickedOutsideDirective } from './directives/clicked-outside.directive';
import { ContextMenuDirective } from './directives/context-menu.directive';
import { MousedownOutsideDirective } from './directives/mousedown-outside.directive';
import { PremiumCoverDirective } from './directives/premium-cover.directive';
import { ColorPipe } from './pipes/color.pipe';
import { IndexedNamePipe } from './pipes/indexed-name.pipe';
import { UnitPipe } from './pipes/unit.pipe';
import { InputPlusMinusComponent } from './components/input-plus-minus/input-plus-minus.component';
import { ProjectPreviewComponent } from './components/project-preview/project-preview.component';
import { ModalHintComponent } from './components/modal-hint/modal-hint.component';
import { MultiStopEditComponent } from './components/multi-stop-edit/multi-stop-edit.component';
import { AxleLoadsComponent } from './components/axle-loads/axle-loads.component';
import { SliderComponent } from './components/slider/slider.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { IconCheckboxComponent } from './components/icon-checkbox/icon-checkbox.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { LoadArrangementComponent } from './components/load-arrangment/load-arrangement.component';
import { LabelCheckboxComponent } from './components/label-checkbox/label-checkbox.component';

@NgModule({
    declarations: [
        IconComponent,
        ButtonComponent,
        InputComponent,
        InputContainerComponent,
        BoxComponent,
        SlideToggleComponent,
        LoadFormComponent,
        LoadingSpaceFormComponent,
        ClickedOutsideDirective,
        ButtonToggleComponent,
        UnitPipe,
        IndexedNamePipe,
        ColorPipe,
        ContextMenuDirective,
        ErrorComponent,
        LinkComponent,
        SelectComponent,
        OptionComponent,
        TooltipComponent,
        TooltipDirective,
        RadioButtonComponent,
        MousedownOutsideDirective,
        SearchInputComponent,
        CheckboxComponent,
        PremiumCoverDirective,
        ProIconComponent,
        ModalTooltipComponent,
        InputPlusMinusComponent,
        ProjectPreviewComponent,
        ModalHintComponent,
        MultiStopEditComponent,
        AxleLoadsComponent,
        SliderComponent,
        ColorPickerComponent,
        IconCheckboxComponent,
        TextareaComponent,
        LoadArrangementComponent,
        LabelCheckboxComponent,
    ],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, OverlayModule, TranslateModule],
    providers: [ColorPipe],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        IconComponent,
        ButtonComponent,
        InputComponent,
        InputContainerComponent,
        BoxComponent,
        SlideToggleComponent,
        LoadFormComponent,
        ClickedOutsideDirective,
        ButtonToggleComponent,
        UnitPipe,
        IndexedNamePipe,
        ColorPipe,
        ContextMenuDirective,
        ErrorComponent,
        LinkComponent,
        SelectComponent,
        OptionComponent,
        TooltipComponent,
        TooltipDirective,
        RadioButtonComponent,
        TranslateModule,
        MousedownOutsideDirective,
        SearchInputComponent,
        CheckboxComponent,
        PremiumCoverDirective,
        ProIconComponent,
        ModalTooltipComponent,
        InputPlusMinusComponent,
        ProjectPreviewComponent,
        ModalHintComponent,
        MultiStopEditComponent,
        AxleLoadsComponent,
        SliderComponent,
        ColorPickerComponent,
        IconCheckboxComponent,
        LoadArrangementComponent,
        LabelCheckboxComponent
    ]
})
export class SharedModule {}
